import { Link } from "react-router-dom";
import { Trophy, Timer, Move, Gift } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { fmt } from "@/lib/api";
import GiftShowcase from "./GiftShowcase";
import Leaderboard from "./Leaderboard";

export default function ChallengeSection() {
  const { config, openGame } = useSite();
  const g = config.game;
  const steps = [
    { Icon: Move, t: "Qonşu simvolu sürüşdürün", d: "Üfüqi və ya şaquli 3+ eyni simvol düzün." },
    { Icon: Timer, t: `${g.duration_sec} saniyə`, d: "Vaxt bitənə qədər maksimum xal toplayın." },
    { Icon: Trophy, t: `${fmt(g.target_score)} xal`, d: "Hədəfə çatın — nəticəni server yoxlayır." },
    { Icon: Gift, t: "6 hədiyyə qutusu", d: "Qarışdırılmış qutulardan birini seçin və hədiyyənizi 72 saat ərzində alın." },
  ];
  return (
    <section id="challenge" data-testid="challenge-section" className="py-20 md:py-24 scroll-mt-16">
      <div className="container-lm grid lg:grid-cols-[1fr_1.2fr] gap-12 items-center">
        <div>
          <p className="eyebrow">LiveMedia Challenge · Gold Grid</p>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold mt-4">Kiçik bir oyun, böyük fürsət!</h2>
          <p className="text-[#77736B] mt-4 max-w-md leading-relaxed text-sm md:text-base">
            {fmt(g.target_score)} xal topla və hədiyyə qutusu qazan! Qeydiyyat tələb olunmur — oyun birbaşa bu səhifədə açılır.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            {g.enabled && <button onClick={() => openGame("play")} className="btn-dark" data-testid="challenge-play-btn">Oyuna başla</button>}
            <button onClick={() => openGame("rules")} className="btn-ghost" data-testid="challenge-rules-btn">Qaydalar</button>
          </div>
          <Link to="/mexfilik#endirim" className="text-xs text-[#77736B] underline underline-offset-4 mt-6 inline-block" data-testid="challenge-terms-link">
            Hədiyyə şərtləri
          </Link>
        </div>
        <ol className="grid sm:grid-cols-2 gap-4">
          {steps.map(({ Icon, t, d }, i) => (
            <li key={i} className="rounded-2xl bg-white/60 border border-[#171715]/8 p-6" data-testid={`challenge-step-${i}`}>
              <div className="flex items-center justify-between">
                <Icon size={20} strokeWidth={1.6} className="text-[#b58a3f]" />
                <span className="text-[11px] text-[#77736B]">0{i + 1}</span>
              </div>
              <p className="font-display font-semibold mt-5">{t}</p>
              <p className="text-sm text-[#77736B] mt-2 leading-relaxed">{d}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className="container-lm mt-12">
        <GiftShowcase />
        <div className="mt-8"><Leaderboard /></div>
      </div>
    </section>
  );
}
